<template>
  <footer class="">
    <!-- Fixed navbar -->
    <nav class="navbar navbar-expand-md static-top">
      <div class="" id="">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link to="/terms-and-conditions" class="nav-link">
              Terms and Conditions
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/login" class="nav-link">
              Administrator Login
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped></style>
